<template>
    <div class="mobile-toolbar">
      <button class="tool-btn" type="button" @click="$emit('open')">
        <span class="icon">📝</span>
        <span class="label">文字框 ({{ count }})</span>
      </button>
    </div>
  </template>
  
  <script setup lang="ts">
  defineProps<{ count: number }>()
  defineEmits<{ (e: 'open'): void }>()
  </script>
  
  <style scoped lang="scss">
  .mobile-toolbar { display: none; }
  @media (max-width: 720px) {
    .mobile-toolbar {
      position: fixed;
      bottom: 12px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 40;
  
      .tool-btn {
        height: 52px;
        padding: 0 20px;
        border-radius: 999px;
        border: 1px solid rgba(255,255,255,0.10);
        background: linear-gradient(180deg, rgba(29,123,255,1), rgba(29,123,255,0.85));
        box-shadow: 0 4px 16px rgba(29,123,255,0.4);
        color: #fff;
        font-weight: 700;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
  
        &:active { transform: scale(0.95); }
      }
    }
  }
  </style>
  